import React from 'react'
import ReactDOM from 'react-dom/client'

import '@fontsource/noto-sans/latin-400.css'
import '@fontsource/noto-sans/latin-700.css'
import '@fontsource/roboto-mono/latin-400.css'
import * as Sentry from '@sentry/react'

import App from './App'
import { initSentry } from './sentry'
import './styles/main.css'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className='flex min-h-screen items-center justify-center p-8 text-center text-slate-200'>
          予期せぬエラーが発生しました。ページを再読み込みしてください。
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
